import React from "react";
import ServiceIconBase, { ServiceIconProps } from "./ServiceIconBase";

/** Camcorder body with the lens wedge — "Cámaras de seguridad". */
export const SecurityCameraIcon: React.FC<ServiceIconProps> = ({ size }) => (
  <ServiceIconBase size={size}>
    <rect x="2" y="7" width="13" height="10" rx="2" />
    <path d="M15 11.5l6.2-3.6a.6.6 0 0 1 .9.5v7.2a.6.6 0 0 1-.9.5L15 12.5z" />
  </ServiceIconBase>
);

export default SecurityCameraIcon;
